import useControlledState from '@quid/react-use-controlled-state';
import { useLayoutEffect } from 'react';
import { unselect } from '@clds/compound-components';
const useSyncOnChange = (observerValue, syncCallback) => {
    useLayoutEffect(() => {
        if (observerValue !== undefined && observerValue !== unselect) {
            syncCallback(observerValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [observerValue]);
};
export const useMenuState = (props) => {
    const [focusedId, setFocusedId] = useControlledState(props.defaultFocusedId === undefined && props.focusedId === undefined
        ? unselect
        : props.defaultFocusedId, props.focusedId, props.onFocusedIdChange);
    const [selectedId, setSelectedId] = useControlledState(props.defaultSelectedId === undefined && props.selectedId === undefined
        ? unselect
        : props.defaultSelectedId, props.selectedId, props.onSelect);
    useSyncOnChange(selectedId, setFocusedId);
    const cancel = () => {
        setFocusedId(unselect);
        setSelectedId(unselect);
    };
    const select = (id) => {
        setFocusedId(id);
        setSelectedId(id);
    };
    return {
        focusedId,
        setFocusedId,
        selectedId,
        cancel,
        select,
    };
};
//# sourceMappingURL=useMenuState.js.map